/**
 *
 * Settings:
 *
 *   window.sw.data.userLists - specifies models and configurations added to particular lists.
 *
 * Usage:
 *
 *   data-sw-add-list=<list-name>
 *   data-sw-add-list-change-config-for-spin=<product spin>
 *   data-sw-add-list-is-public=<product is public>
 *   data-sw-add-list-listed-text=<text to show if product is in list> | optional
 *   data-sw-add-list-not-listed=<text to show if product is not in list> | optional
 *   data-sw-add-list-list-url=<url to view the specified list>
 *
 * Events:
 *   @publishes favorites-clicked <html fragment>
 *
 */

var $ = require('js/sw-jquery/sw-jquery');
var notifications = require('js/lib/notifications/sw-notifications');
var url = require('url');

var HIDDEN_CLASS = 'sw--is-hidden';
var ATTR_ADD_URL = 'data-sw-add-list-add-url';
var ATTR_REMOVE_URL = 'data-sw-add-list-remove-url';
var ATTR_TRACKING_LINK_ID = 'data-sw-tracking-link-id';
var TRACKING_LINK_ID_ADD = 'add';
var TRACKING_LINK_ID_REMOVE = 'remove';

$(function() {
  $('body').on('click', '[data-sw-add-list]', function(e) {

    var $el = $(this);

    if($el.is('a')) {
      e.preventDefault();
      $el.blur();
    }

    $.swAjax({
      url: $el.attr('href'),
      type: 'POST',
      dataType: 'json',
      success: function (data) {
        var success = data.result && (data.result.toLowerCase() === 'success');
        if (!success) {
          notifications.error('Oops, somthing went wrong');
          return;
        }

        var wasAdded = $el.data('swAddListIsAdded');
        var $isAddedContent = $el.find('[data-sw-add-list-content-added]');
        var $notAddedcontent = $el.find('[data-sw-add-list-content-not-added]');
        var newHref = '';

        if (wasAdded) {
          newHref = $el.attr(ATTR_ADD_URL);
          $isAddedContent.addClass(HIDDEN_CLASS);
          $notAddedcontent.removeClass(HIDDEN_CLASS);
          $el.attr(ATTR_TRACKING_LINK_ID, TRACKING_LINK_ID_ADD);
        } else {
          newHref = $el.attr(ATTR_REMOVE_URL);
          $isAddedContent.removeClass(HIDDEN_CLASS);
          $notAddedcontent.addClass(HIDDEN_CLASS);
          $el.attr(ATTR_TRACKING_LINK_ID, TRACKING_LINK_ID_REMOVE);
        }

        $el.attr('href', newHref);
        $el.data('swAddListIsAdded', !wasAdded);
      },
      error: function () {
        notifications.error('Oops, somthing went wrong');
      }
    });

  });
});

/**
 * Takes a url and replaces productConfigurationId with new productConfigurationId
 * @param url
 * @param configurationId
 * @return {*}
 */
function replaceConfigInUrl(urlToChange, configurationId) {
  // Reformat the add to list url to contain this configuration id
  var location = url.parse(urlToChange, true); // parse url and query string
  location.query.productConfigurationId = configurationId;
  location.search = null; // force this to be regenerated
  return url.format(location);
}

/**
 *
 * @param $el
 * @param attr
 * @param configurationId
 */
function replaceConfigInAttr($el, attr, configurationId) {
  var newHref = replaceConfigInUrl($el.attr(attr), configurationId);
  $el.attr(attr, newHref);
}

require(['js/lib/models/ModelManager'], function(ModelManager) {
  ModelManager.on('products:change:currentConfigurationId', function(product, configurationId) {
    var spin = product.attributes.spin;

    $('[data-sw-add-list-change-config-for-spin="' + spin + '"]').each(function() {

      var $el = $(this);
      replaceConfigInAttr($el, 'href', configurationId);

    });
  });
});
